import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-menu-slide-down]')) return;

  addEventListeners();
  dataLayerLogoLinks();
}

function addEventListeners() {
  window.addEventListener('scroll', function () {
    const menu = $('[data-au-menu-slide-down]');
    const container = $('#container');
    const menuHeight = menu.offsetHeight;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > menuHeight) {
      menu.classList.add('au-menu-slide-down--slided');
    } else {
      menu.classList.remove('au-menu-slide-down--slided');
    }

    if (container) {
      if (scrollTop > menuHeight) {
        container.style.paddingTop = `${menuHeight}px`;
      } else {
        container.style.paddingTop = `${0}px`;
      }
    }
  });
}

function dataLayerLogoLinks() {
  $$('[data-au-menu-slide-down] a').forEach((logoLink) => {
    logoLink.addEventListener('click', (e) => {
      const clickText = e.currentTarget.querySelector('img').getAttribute('alt');
      const item_id = removeAccentMarkAndUppercase(`logo_${clickText}`);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_content',
        content_type: 'menu superior_logo',
        item_id,
      });
    });
  });
}

export default { init };
